import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useSeek } from '../../hooks/useSeek';
import { useKeyboardHandler } from '../../hooks/useKeyboardHandler';
import { useIcons } from '../../hooks/useIcons';

const FORWARD_DIFF_IN_SECONDS = 15;

export const ForwardButton: FunctionComponent<IconButtonProps> = (props) => {
  const { fastForwardBy } = useSeek();
  const { Forward15 } = useIcons();

  const fastForward = useCallback(() => {
    fastForwardBy(FORWARD_DIFF_IN_SECONDS);
  }, [fastForwardBy]);

  const handleKeydown = useCallback(
    (e: KeyboardEvent) => {
      if (e.code === 'ArrowRight') {
        fastForward();
      }
    },
    [fastForward]
  );

  useKeyboardHandler(handleKeydown);

  return (
    <IconButton onClick={fastForward} {...props}>
      <Forward15 />
    </IconButton>
  );
};
